import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-neon",
  "use": "icon-play-neon-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\" id=\"icon-play-neon\"><rect width=\"80\" height=\"80\" rx=\"40\" fill=\"#CDFF00\" /><path d=\"M56 41.333 32 56V26.666l24 14.667Z\" fill=\"#2B2E30\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol